class ComponentProductForm extends Theme.Component {
  #submitting = false;

  constructor() {
    super();
  }

  connectedCallback() {
    this.section = this.closest("component-section");

    this.defineElements({
      form: "form",
      selling_plan: "[name=selling_plan]"
    });

    this.defineElementCollections({
      links: "link[rel=prefetch]"
    });

    this.addEvent("submit", this.elements.form, this.onSubmit);
    this.addEvent("change", this, this.onChange);

    this.prefetchURLs();
    this.events();
  }

  prefetchURLs() {
    this.observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) {
          continue;
        }

        fetch(entry.href, { cache: "force-cache" });
        observer.unobserve(entry.target);
      }
    }, { rootMargin: '100px' });

    this.elements.links.forEach((element) => {
      this.observer.observe(element);
    });
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.#submitting) {
      return;
    }

    this.#submitting = true;

    const data = new FormData(this.elements.form);

    fetch("/cart/add.js", {
      method: "POST",
      body: data
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent("addtocart", {
        detail: response
      }));
    })
    .catch(error => {
      console.error("ProductFormSubmitError: ", error);
    })
    .finally(() => {
      this.#submitting = false;
    });
  }

  onChange(event) {
    if (event.target.hasAttribute("data-gift-card")) {
      return;
    }

    if (event.target.name == "id") {
      this.onVariantChange(event);
    }

    if (event.target.name == "purchase") {
      this.onPurchaseChange(event);
    }
  }

  onVariantChange(event) {
    const variant_id = event.target.value;

    Theme.URLParams.set("variant", variant_id);

    this.section.render({ variant: variant_id });

    document.dispatchEvent(new CustomEvent("product:variantchange", {
      detail: { variant_id }
    }));
  }

  onPurchaseChange(event) {
    if (event.target.value == "one-time") {
      this.elements.selling_plan.setAttribute("disabled", "");
      Theme.URLParams.delete("selling_plan");
    }

    if (event.target.value == "subscription") {
      this.elements.selling_plan.removeAttribute("disabled");
      Theme.URLParams.set("selling_plan", this.elements.selling_plan.value);
    }
  }
}

customElements.define("component-product-form", ComponentProductForm);
